import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getUserAddressFailure,
  getUserAddressRequest,
  getUserAddressSuccess
} from './getUserAddressSlice';
import i18next from 'i18next';
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from '../../constants/AppConstants';
import { _CALLGETAPI } from '../../api/apiHandler';
import { getLocalSessionData } from '../../utils/Authentication/handleUserSession';

function _GET_USER_ADDRESS(userId) {
  const endpoint = _API_ENDPOINT.GET_USER_ADDRESS;
  const payload = {
    params: {
      userId: userId
    }
  };
  return _CALLGETAPI(endpoint, payload)
    .then(response => response)
    .catch(error => { throw error });
}

function* getUserAddressSaga(action) {
  try {
    const userId =getLocalSessionData(LOCALSESSIONDATAKEYS.UID)
    const addressData = yield call(_GET_USER_ADDRESS, userId);

    if (addressData?.actionStatus.toUpperCase() === SUCCESS) {
      yield put(getUserAddressSuccess(addressData));
    } else {
      yield put(getUserAddressFailure(i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')));
    }
  } catch (error) {
     yield put(getUserAddressFailure(error.message));
  }
}

export default function* watchGetUserAddressService() {
  yield takeEvery(getUserAddressRequest.type, getUserAddressSaga);
}
